import TickSquareSuccess from 'assets/icons/tick-square.svg';
import InfoSquareRed from 'assets/icons/info-square-red.svg';
import TimeCirclePending from 'assets/icons/time-circle-pending.svg';
import {
  statusError,
  statusNeutral,
  statusSuccess,
  statusTextError,
  statusTextNeutral,
  statusTextSuccess,
} from 'utils/color-styles';

export const VOLUNTEER_TIME_APPROVAL = {
  Pending: {
    name: 'Pending',
    icon: TimeCirclePending,
    chipColor: statusNeutral,
    textColor: statusTextNeutral,
  },
  Approved: {
    name: 'Approved',
    icon: TickSquareSuccess,
    chipColor: statusSuccess,
    textColor: statusTextSuccess,
  },
  Rejected: {
    name: 'Rejected',
    icon: InfoSquareRed,
    chipColor: statusError,
    textColor: statusTextError,
  },
};

export const VOLUNTEER_TIME_OFF_STATUSES = {
  REQUESTED: {
    name: 'Requested',
    icon: TimeCirclePending,
    chipColor: statusNeutral,
    textColor: statusTextNeutral,
  },
  APPROVED: {
    name: 'Approved',
    icon: TickSquareSuccess,
    chipColor: statusSuccess,
    textColor: statusTextSuccess,
  },
  DECLINED: {
    name: 'Declined',
    icon: InfoSquareRed,
    chipColor: statusError,
    textColor: statusTextError,
  },
  CANCELLED: {
    name: 'Cancelled',
    icon: InfoSquareRed,
    chipColor: statusError,
    textColor: statusTextError,
  },
  DELETED: {
    name: 'Deleted',
    icon: InfoSquareRed,
    chipColor: statusError,
    textColor: statusTextError,
  },
};
